import { FormControlLabel, Radio, TextField } from "@mui/material";
import { addOpacityToHexColor } from "../../../utils/addOpacityToHexColor";

const TableSheetChoices = ({ selections, question, themeColors }) => {
    function choicesData() {
        if (question && question.choices && question.choices.data) {
            return question.choices.data;
        }
        return [];
    }

    return (
        <div className="relative">
            <table className="my-10 rounded-t-md overflow-hidden w-full">
                <thead
                    style={{
                        backgroundColor: themeColors.primaryColor,
                    }}
                    className="text-white"
                >
                    <tr className="space-x-5">
                        <th className="py-4 text-sm w-[500px]">Goal</th>
                        <th className="py-4 text-sm">Within the next year</th>
                        <th className="py-4 text-sm">Within the next 5 years</th>
                        <th className="py-4 text-sm">In the next 5+ years</th>
                    </tr>
                </thead>
                <tbody>
                    {choicesData().map((choice, index) => selections[question.id] && selections[question.id][choice.id] && (
                        <tr
                            key={index}
                            style={{
                                backgroundColor:
                                    index % 2 == 1 ? addOpacityToHexColor(themeColors.secondaryColor, 0.1) : "",
                            }}
                        >
                            <td className="p-3">
                                {choice.label}
                                <br />

                                {JSON.stringify(choice).includes("with_textbox") ? (
                                    <TextField
                                        multiline={true}
                                        variant="outlined"
                                        size="small"
                                        value={
                                            selections[question.id] &&
                                            selections[question.id][choice.id + "_textbox"] &&
                                            selections[question.id][choice.id + "_textbox"].answer
                                        }
                                    ></TextField>
                                ) : (
                                    ""
                                )}
                            </td>

                            <td className="text-center py-3 text-sm">
                                <FormControlLabel
                                    name={choice.label}
                                    className="margin-0"
                                    value="col2"
                                    checked={
                                        selections[question.id]
                                            ? selections[question.id][choice.id]
                                                ? selections[question.id][choice.id].answer === "col2"
                                                : false
                                            : false
                                    }
                                    control={
                                        <Radio
                                            style={{
                                                color: themeColors.primaryColor,
                                            }}
                                            name={choice.label}
                                        />
                                    }
                                />
                            </td>
                            <td className="text-center py-3 text-sm">
                                <FormControlLabel
                                    name={choice.label}
                                    className="margin-0"
                                    value="col3"
                                    checked={
                                        selections[question.id]
                                            ? selections[question.id][choice.id]
                                                ? selections[question.id][choice.id].answer === "col3"
                                                : false
                                            : false
                                    }
                                    control={
                                        <Radio
                                            style={{
                                                color: themeColors.primaryColor,
                                            }}
                                            name={choice.label}
                                        />
                                    }
                                />
                            </td>
                            <td className="text-center py-3 text-sm">
                                <FormControlLabel
                                    name={choice.label}
                                    className="margin-0"
                                    value="col4"
                                    checked={
                                        selections[question.id]
                                            ? selections[question.id][choice.id]
                                                ? selections[question.id][choice.id].answer === "col4"
                                                : false
                                            : false
                                    }
                                    control={
                                        <Radio
                                            style={{
                                                color: themeColors.primaryColor,
                                            }}
                                            name={choice.label}
                                        />
                                    }
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSheetChoices;
